/* B2B product visibility - client-side cleanup for JSON rendered surfaces.
   Server rendered grids are already filtered in Liquid; this only catches
   predictive search and any widget that injects product links after load. */
(function () {
  'use strict';

  var CARD_SELECTOR = 'li, .grid__item, .product-item, .predictive-search__item, .search-result';

  function hiddenHandles() {
    return window.b2bHiddenHandles || [];
  }

  function handleFromHref(href) {
    var match = String(href).match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function pruneWithin(root) {
    var handles = hiddenHandles();
    if (!handles.length || !root || !root.querySelectorAll) return;

    var links = root.querySelectorAll('a[href*="/products/"]');
    var i, handle, card;

    for (i = 0; i < links.length; i++) {
      handle = handleFromHref(links[i].getAttribute('href'));
      if (!handle) continue;
      if (handles.indexOf(handle) === -1) continue;

      card = links[i].closest ? links[i].closest(CARD_SELECTOR) : null;
      if (card && card.parentNode) {
        card.parentNode.removeChild(card);
      } else if (links[i].parentNode) {
        links[i].parentNode.removeChild(links[i]);
      }
    }
  }

  function start() {
    if (!hiddenHandles().length) return;

    pruneWithin(document);

    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      var i, j, node;
      for (i = 0; i < mutations.length; i++) {
        for (j = 0; j < mutations[i].addedNodes.length; j++) {
          node = mutations[i].addedNodes[j];
          if (node.nodeType === 1) pruneWithin(node);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
